// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6384319a","616":"b1c5088c"}[chunkId] + ".chunk.js";
};